export class MessageRequest {
    Message: string = null;
    Target: number = null;
    Type: number = 1;
    TypeID: string[] = [];
}